import { useEffect, useCallback, useState } from 'react';
import loadable from '@loadable/component';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { pathToAction } from 'redux-first-router';
import { useDispatch } from 'react-redux';
import routesGenerator from '@/router/routesGenerator';

const BriefModal = loadable(() => import('./BriefModal'));

const BriefModalOnLoad = () => {
  const dispatch = useDispatch();
  // Catch if brief modal should be rendered on load due to query param
  const { getItem } = useQueryStringParam();
  const activityId = getItem('brief');
  const companyId = getItem('company');
  const [showBriefModal, setShowBriefModal] = useState(false);
  useEffect(() => {
    // Check if there's a query string briefId and the BriefModal needs to show
    if (companyId !== null && activityId !== null && showBriefModal === false) {
      setShowBriefModal(true);
    }
  }, [activityId, showBriefModal]);
  const handleBriefModalClose = useCallback(() => {
    const action = pathToAction(window.location.pathname, routesGenerator());
    setShowBriefModal(false);
    dispatch(action);
  }, []);
  return (
    <>
      {showBriefModal && companyId !== null && activityId !== null && (
        <BriefModal
          onClose={handleBriefModalClose}
          companyId={companyId}
          activityId={activityId}
        />
      )}
    </>
  );
};

export default BriefModalOnLoad;
